import React from 'react'

function CenterTextMainBanner({ Heading, Image }) {
  return (
    <div className="page-title-wrap typo-white">
      <div
        className="page-title-wrap-inner banner-section-bg-img"
        style={{
          backgroundImage: `url(/assets/images/banners/${Image ? Image : 'theme-2-banner-login.webp'})`,
        }}

      >
        {/* <span className="black-overlay"></span> */}
        <div className="container">
          <div className="row text-center">
            <div className="col-md-12">
              <div className="page-title-inner">
                <h1 className="page-title mb-0">{Heading}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CenterTextMainBanner
